"use client"

import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu"
import {
  EVALUATION_DASHBOARD_APPROACHES,
  setEvaluationDashboardApproach,
  useEvaluationDashboardApproach,
} from "@/hooks/use-evaluation-dashboard-approach"

export function EvaluationDashboardApproachMenu() {
  const approach = useEvaluationDashboardApproach()
  const active = EVALUATION_DASHBOARD_APPROACHES.find(option => option.id === approach)

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <i className="fa-light fa-chart-line" aria-hidden="true" />
        Evaluations dashboard
        <span className="ms-auto pe-1 text-xs text-muted-foreground">{active?.label}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-64">
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
          Surveys and Course Evaluations
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={approach}
          onValueChange={value => {
            setEvaluationDashboardApproach(value as typeof approach)
          }}
        >
          {EVALUATION_DASHBOARD_APPROACHES.map(option => (
            <DropdownMenuRadioItem
              key={option.id}
              value={option.id}
              className="items-start gap-2 py-2"
            >
              <span className="flex flex-col gap-0.5">
                <span className="font-medium">{option.label}</span>
                <span className="text-xs leading-snug text-muted-foreground">
                  {option.description}
                </span>
              </span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
